<!--
  - ===========================================================================
  - [StrongGate Limited] [http://www.stronggate.com]
  - Copyright (c) 2023-2024. All rights Reserved.
  - Unauthorized access, use, dissemination, distribution, reproduction of this
  - file, or a portion of, in any form is prohibited and unlawful. If you receive
  - this file, and you are not an authorized company employee, or you believe you
  - have received this file in error, please notify the sender (or originator)
  - and promptly delete this file.
  -
  - Project:
  - File: geo-proxy.vue
  - Created by: ChanYing
  - Create Date: 2024-01-30 16:04
  - Version Number: 1.0
  - Version Description:
  -
  - =============================================================================
  -->

<template>
  <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path id="Shape" fill-rule="evenodd" clip-rule="evenodd"
          d="M16.586 7.15499C16.5452 7.06666 16.4943 6.98249 16.4227 6.91082L11.4227 1.91082C11.351 1.83916 11.2668 1.78832 11.1785 1.74749C11.1535 1.73582 11.1268 1.72916 11.1002 1.71999C11.0302 1.69666 10.9585 1.68166 10.8843 1.67749C10.8668 1.67582 10.851 1.66666 10.8335 1.66666H5.00016C4.081 1.66666 3.3335 2.41416 3.3335 3.33332V16.6667C3.3335 17.5858 4.081 18.3333 5.00016 18.3333H15.0002C15.9193 18.3333 16.6668 17.5858 16.6668 16.6667V7.49999C16.6668 7.48249 16.6577 7.46666 16.656 7.44832C16.6518 7.37416 16.6377 7.30249 16.6135 7.23249C16.6052 7.20582 16.5977 7.17999 16.586 7.15499ZM13.822 6.66666H11.667V4.51166L13.822 6.66666ZM5 16.6666V3.33331H10V7.49998C10 7.96081 10.3725 8.33331 10.8333 8.33331H15L15.0017 16.6666H5Z"
          :fill="strokeColor"/>
    <path id="Shape_2" fill-rule="evenodd" clip-rule="evenodd"
          d="M6.6665 10H13.3332V11.6667H6.6665V10ZM6.6665 13.3333H13.3332V15H6.6665V13.3333ZM6.6665 6.66666H8.33317V8.33332H6.6665V6.66666Z"
          :fill="strokeColor"/>
  </svg>

</template>

<script>
export default {
  name: "geo-proxy",
  props: {
    strokeColor: {
      type: String,
      default: "var(--body-aux-1)"
    }
  },
}
</script>

